const SW = ({ width, height, color, ...props }) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="3.42999" width="24" height="17.1429" rx="2" fill="white" />
    <mask
      id="mask0_54_2973"
      maskUnits="userSpaceOnUse"
      x="0"
      y="3"
      width="24"
      height="18"
    >
      <rect y="3.42999" width="24" height="17.1429" rx="2" fill="white" />
    </mask>
    <g mask="url(#mask0_54_2973)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.00142H24V3.42999H0V8.00142Z"
        fill="#262626"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.5729H24V16.0014H0V20.5729Z"
        fill="#018301"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 16.0014H24V8.0014H0V16.0014Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14.8586H24V9.14429H0V14.8586Z"
        fill="#DC0808"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 17.7157C13.1429 17.7157 14.8572 15.4729 14.8572 12.0014C14.8572 8.52989 13.1429 6.28711 12 6.28711C10.8572 6.28711 9.14288 8.52989 9.14288 12.0014C9.14288 15.4729 10.8572 17.7157 12 17.7157Z"
        fill="#BC0000"
      />
      <mask
        id="mask1_54_2973"
        maskUnits="userSpaceOnUse"
        x="9"
        y="6"
        width="6"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 17.7157C13.1429 17.7157 14.8572 15.4729 14.8572 12.0014C14.8572 8.52989 13.1429 6.28711 12 6.28711C10.8572 6.28711 9.14288 8.52989 9.14288 12.0014C9.14288 15.4729 10.8572 17.7157 12 17.7157Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_54_2973)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.42862 18.2871C9.00658 18.2871 10.2858 15.4729 10.2858 12.0014C10.2858 8.52988 9.00658 5.71567 7.42862 5.71567C5.85066 5.71567 4.57148 8.52988 4.57148 12.0014C4.57148 15.4729 5.85066 18.2871 7.42862 18.2871Z"
          fill="#262626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5714 18.2871C18.1494 18.2871 19.4286 15.4729 19.4286 12.0014C19.4286 8.52988 18.1494 5.71567 16.5714 5.71567C14.9935 5.71567 13.7143 8.52988 13.7143 12.0014C13.7143 15.4729 14.9935 18.2871 16.5714 18.2871Z"
          fill="#262626"
        />
        <g filter="url(#filter0_d_54_2973)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5715 8.00138C12.5715 9.26109 12.3167 10.2828 12.002 10.2871C12.3167 10.2903 12.5715 11.0566 12.5715 12.0014C12.5715 12.9481 12.3156 13.7156 12 13.7156C11.6845 13.7156 11.4286 12.9481 11.4286 12.0014C11.4286 11.0566 11.6834 10.2903 11.9981 10.2871C11.6834 10.2828 11.4286 9.26109 11.4286 8.00138C11.4286 6.73902 11.6845 5.71567 12 5.71567C12.3156 5.71567 12.5715 6.73902 12.5715 8.00138ZM12 13.7156C11.6845 13.7156 11.4286 14.739 11.4286 16.0014C11.4286 17.2637 11.6845 18.2871 12 18.2871C12.3156 18.2871 12.5715 17.2637 12.5715 16.0014C12.5715 14.739 12.3156 13.7156 12 13.7156Z"
            fill="url(#paint0_linear_54_2973)"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_54_2973"
        x="11.4286"
        y="5.71567"
        width="1.14286"
        height="13.5714"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_54_2973"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_54_2973"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_54_2973"
        x1="11.4286"
        y1="5.71567"
        x2="11.4286"
        y2="18.2871"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F0F0F0" />
      </linearGradient>
    </defs>
  </svg>
);

export default SW;
